<template>
  <v-simple-table
    class="simple-table"
    :height="height"
    :dense="dense"
    :fixed-header="fixedHeader"
    :style="`backgroundColor:${color}`"
  >
    <template v-slot:default>
      <thead>
      <tr>
        <th
          v-for="(fieldRow, index) in header"
          :key="index"
          :class="fieldRow.class ? fieldRow.class : ''"
          :style="`backgroundColor:${color}`"
        >
          {{ fieldRow.label }}
        </th>
      </tr>
      </thead>
      <tbody v-if="desserts">
      <tr
        v-for="(installment, index) in desserts"
        :key="index"
        :id="`tableRow${_uid}${index}`"
        :class="installment.class"
        :style="`color:${fontColor}`"
        @click="rowClickHandler(index, installment)"
      >
        <td
          v-for="(fieldRow, fIndex) in header"
          :key="fIndex"
          :class="fieldRow.template === 'checkIcon' ? 'text-center' : '' || fieldRow.class ? fieldRow.class : '' "
        >
          <template v-if="fieldRow.fieldKey === 'action'">
            <template v-if="creditAction && index === 0">
              <arb-btn-menu
                v-if="isLockedByCurrentUser()"
                v-model="installment.action.actionList"
                :icon="fieldRow.icon"
                btnType="iconBtn"
                :belongTo="installment"
                :disabled="installment.action.disabled"
              ></arb-btn-menu>
            </template>
            <template v-else>
              <arb-btn-menu
                v-if="index > 0 && isLockedByCurrentUser()"
                v-model="installment.action.actionList"
                :icon="fieldRow.icon"
                btnType="iconBtn"
                :belongTo="installment"
                :disabled="installment.action.disabled"
              ></arb-btn-menu>
              <v-btn v-else-if="index > 0 && !isLockedByCurrentUser()" x-small icon>
                <v-icon color="grey">menu</v-icon>
              </v-btn>
            </template>
          </template>
          <template v-else-if="fieldRow.template === 'checkIcon'">
            <v-icon v-if="installment[fieldRow.fieldKey] === dataType.SignStatusEnum.SIGNED.value" style="font-size: 20px !important;" color="primary">check</v-icon>
            <v-icon small v-else style="font-size: 14px !important;">fas fa-question</v-icon>
          </template>
          <template v-else>
            {{ rowRender(installment, fieldRow, index) }}
          </template>
        </td>
      </tr>
      </tbody>
    </template>
  </v-simple-table>
</template>

<script>
import { Tool, DataType, Authentication } from '@/util/index'
export default {
  name: 'arb-simple-table',
  props: {
    /*
    * @description
    * desserts: table data
    */
    desserts: {
      type: Array
    },
    /*
    * @description
    * color: backgroundColor of table
    */
    color: {
      type: String,
      default: '#e1f5fe'
    },
    /*
    * @description
    * fontColor: fontColor of table
    */
    fontColor: {
      type: String,
      default: 'black'
    },
    /*
    * @description
    * header: table header
    */
    header: {
      type: Array
    },
    /*
    * @description
    * height: table height
    */
    height: {
      type: [Number, String],
      default: 100
    },
    /*
    * @description
    * dense: true | false
    */
    dense: {
      type: Boolean,
      default: true
    },
    /*
    * @description: whether table header is fixed
    * fixedHeader: true | false
    */
    fixedHeader: {
      type: Boolean,
      default: true
    },
    /*
    * @description: whether table row has action when it be clicked
    * clickAction: true | false
    */
    clickAction: {
      type: [Boolean, String],
      default: false
    },
    /*
    * @description: whether the index need reverse
    * clickAction: true | false
    */
    reverseIndex: {
      type: [Boolean, String],
      default: false
    },
    transactionProviderList: {
      type: Array,
      default: () => []
    },
    hasCreditAction: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      tool: new Tool(),
      dataType: DataType,
      currentLockedId: null,
      creditAction: false
    }
  },
  watch: {
    hasCreditAction: {
      handler: function (val) {
        this.creditAction = val
      },
      deep: true,
      immediate: true
    }
  },
  mounted () {
    this.creditAction = this.hasCreditAction
    this.$eventBus.$on('broadcastLockedId', target => {
      this.currentLockedId = target
    })
  },
  methods: {
    rowClickHandler (rowIndex, rowItem) {
      if (this.clickAction) {
        for (let index = 0; index < this.desserts.length; index++) {
          if (index === rowIndex) {
            this.beGrey(rowIndex)
            this.$emit('row-clicked-event', rowItem)
          } else {
            this.beNormal(index)
          }
        }
      }
    },
    beGrey (index) {
      const idName = 'tableRow' + this._uid + index
      document.getElementById(idName).style.backgroundColor = 'lightGrey'
    },
    beNormal (index) {
      const idName = 'tableRow' + this._uid + index
      document.getElementById(idName).style.backgroundColor = this.color
    },
    rowRender (rowData, fieldRow, rowIndex) {
      if (this.reverseIndex && fieldRow.template === '{index}') {
        return this.desserts.length - rowIndex
      } if (!this.reverseIndex && fieldRow.template === '{index}') {
        return rowIndex + 1
      } else if (fieldRow.fieldKey === 'transactionMode') {
        const transactionModeText = rowData.transactionModeText
        if (this.tool.isNotEmpty(transactionModeText)) {
          return transactionModeText
        } else {
          return this.tool.fieldRender(rowData, fieldRow.template, fieldRow.format, fieldRow.options)
        }
      } else if (fieldRow.fieldKey === 'transactionProvider') {
        let result = ''
        for (const item of this.transactionProviderList) {
          if (item.id === rowData.transactionProvider) {
            result = item.providerName
          }
        }
        return result
      } else {
        return this.tool.fieldRender(rowData, fieldRow.template, fieldRow.format, fieldRow.options)
      }
    },
    isLockedByCurrentUser () {
      return Authentication.isLockedByCurrentUser(this.store.getters.getAccount, this.currentLockedId)
    }
  }
}
</script>

<style lang="scss">
.simple-table {
  table {
    thead th {
      white-space: nowrap;
    }
    tbody {
      td {
        border-bottom: none !important;
        white-space: nowrap;
        height: 26px !important;
      }
    }
  }
}
</style>
